module.exports = __webpack_public_path__ + "img/MDSAP.ce14b259.webp";